import DataTable from 'react-data-table-component';
import { Button } from 'react-bootstrap';
import Icon from '../Icon/Icon';

const WhatsAppContactsDataTable = ({
  data,
  loadingData,
  pagination,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDelete,
  onExport,
  onSelectContact,
  onSelectAllContacts,
  selectedContacts = []
}) => {
  const columns = [
    {
       name: '',
       width: '50px',
       selector: (row) => (
         <input
           type="checkbox"
           checked={row.isSelected || false}
           onChange={(e) => onSelectContact && onSelectContact(row, e.target.checked)}
         />
       ),
     },
    {
      name: 'WhatsApp Number',
      sortable: true,
      selector: (row) => row.whatsappNumber,
    },
    {
      name: 'Name',
      sortable: true,
      selector: (row) => row.name,
    },
    {
      name: 'Country',
      sortable: true,
      selector: (row) => row.country,
    },
     {
       name: 'Action',
       width: '150px',
       selector: (row) => (
         <div className="d-flex justify-content-center align-items-center gap-2">
           <Button
             variant="link"
             className="p-0"
             onClick={() => onEdit && onEdit(row)}
             title="Edit"
             disabled={!onEdit}
           >
             <Icon
               name="edit"
               color="#737C8A"
               width={24}
               height={24}
             />
           </Button>
           <Button
             variant="link"
             className="p-0"
             onClick={() => onExport && onExport([row])}
             title="Export"
           >
             <Icon
               name="export"
               color="#737C8A"
               width={24}
               height={24}
             />
           </Button>
           <Button
             variant="link"
             className="p-0"
             onClick={() => onDelete && onDelete(row)}
             title="Delete"
             disabled={!onDelete}
           >
             <Icon
               name="delete"
               color="#737C8A"
               width={24}
               height={24}
             />
           </Button>
         </div>
       ),
     },
  ];

  return (
    <div className="h-100" style={{
      width: '100%',
      maxWidth: '100%',
      overflowX: 'auto'
    }}>
      <DataTable
        columns={columns}
        data={data}
        progressPending={loadingData}
        pagination
        paginationServer
        paginationTotalRows={pagination?.total || 0}
        paginationPerPage={pagination?.limit || 50}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        onChangePage={onPageChange}
        onChangeRowsPerPage={onRowsPerPageChange}
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
          rangeSeparatorText: 'of',
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        }}
        className="custom-datatable"
        customStyles={{
          table: {
            style: {
              width: '100%',
              maxWidth: '100%',
              borderTopRightRadius: '0px' // Remove top-right rounded corner
            }
          },
          tableWrapper: {
            style: {
              width: '100%',
              maxWidth: '100%',
              overflowX: 'auto',
              borderTopRightRadius: '0px' // Remove top-right rounded corner
            }
          },
          headRow: {
            style: {
              borderTopRightRadius: '0px' // Remove top-right rounded corner from header
            }
          }
        }}
        noDataComponent={
          <div className="text-center py-5">
            <p className="text-muted">No contacts found</p>
          </div>
        }
      />
    </div>
  );
};

export default WhatsAppContactsDataTable;
